import "../styles/normalize.css";
import "../styles/ant-input-number.css";
import "../styles/ant-input-date-picker.css";
import "../styles/ant-input.css";
import "../styles/ant-tooltip.css";
import "../styles/globals.css";

import type { AppProps } from "next/app";
import StylesProvider from "@atlas/uicorn/lib/System/StylesProvider";
import { HelpCenterTheme } from "../lib/load-company-settings";

function HelpCenterApp({ Component, pageProps }: AppProps) {
  return (
    <StylesProvider
      theme={pageProps.appSettings?.theme ?? HelpCenterTheme.AUTO}
    >
      <Component {...pageProps} />
    </StylesProvider>
  );
}

export default HelpCenterApp;
